import { useSelector, useDispatch } from 'react-redux'
import { fetchTasks, setOwnerFilter, setOrder } from '../../store/slices/tasksReducer'
import { setFilters } from '../../store/slices/tasksReducer'
import { Button, Icon, NavigationList, Tag, TagList } from '@a-ui/react';
import { openModal } from '../../store/slices/modalReducer'
import '../../styles/filter.scss';


const TaskFilter = (prop) => {
  const translation = {
    domain: 'Domein',
    dueDate: 'Geplande einddatum',
    plannedStartDate: 'Geplande startdatum',
    priority: 'Prioriteit',
    zone: 'Postcode',
    assignedperson: 'Toegewezen persoon',
    tasktype: 'Taak type',
  }
  const { ownerFilter, order, filters } = useSelector(state => state.tasks)
  const userLocation = useSelector(state => state.userLocation);
  const viewMode = useSelector(state => state.viewMode);
  const dispatch = useDispatch()
  return <div className="filters">
    <div className="row u-margin-top-xs">
      { viewMode.name !== "list" && <div className="col-xs-12 col-md-7 u-margin-bottom">
      <NavigationList
        border={true}
        items={[
          {
            active: ownerFilter === 'mijntaken',
            id: 'mijntaken',
            label: 'Mijn taken'
          },
          {
            active: ownerFilter === 'niettoegekend',
            id: 'niettoegekend',
            label: 'Niet toegekend'
          },
          {
            active: ownerFilter === 'collegas',
            id: 'collegas',
            label: 'Collega’s'
          }
        ]}
        onItemClick={(id) => dispatch(setOwnerFilter(id))}
      />
      </div> }
      <div className={`col-xs-12 ${viewMode.name !== "list" && 'col-md-5'} u-text-right`}>
        <Button
          className="u-margin-bottom-xs u-margin-right-xs"
          emphasis="medium"
          addOn={{
            type: "icon",
            align: "left",
            iconProps: {
              name: "ai-filter-1",
            },
          }}
          onClick={() => dispatch(openModal('Filters'))}
        >Filters</Button>
        <Button
          className="u-margin-bottom-xs u-margin-right-xs"
          addOn={{
            type: "icon",
            align: "left",
            iconProps: {
              name: "ai-add",
            },
          }}
          onClick={() => dispatch(openModal('CreateTask'))}>
          Taak toevoegen
        </Button>
        <Button
          className="u-margin-bottom-xs bigbtnmobile"
          emphasis="medium"
          ariaLabel="Synchroniseren"
          addOn={{
            type: "icon",
            iconProps: {
              name: "ai-synchronize-arrows-1",
            },
          }}
          type="primary"
          size="medium"
          onClick={() => dispatch(fetchTasks())}
        >
        </Button>
      </div>
    </div>
    <div className="row u-margin-top-xs checkboxes">
      { viewMode.name === "list" && <div className="col-xs-12 col-md-7 u-margin-bottom">
      <NavigationList
        border={true}
        items={[
          {
            active: ownerFilter === 'mijntaken',
            id: 'mijntaken',
            label: 'Mijn taken'
          },
          {
            active: ownerFilter === 'niettoegekend',
            id: 'niettoegekend',
            label: 'Niet toegekend'
          },
          {
            active: ownerFilter === 'collegas',
            id: 'collegas',
            label: 'Collega’s'
          }
        ]}
        onItemClick={(id) => dispatch(setOwnerFilter(id))}
      />
      </div> }
      <div className={`col-xs-12 col-md-5 u-text-right u-text-left-xs ${Object.keys(filters).length > 1 ? "u-margin-top-l" : ""}`}>
      { viewMode.name === "list" && <div className="a-input has-icon-right pagesize">
        <label className="a-input__label a-input__label--inline" htmlFor="input-select-inline">Sorteren op</label>
        <div className="a-input__wrapper a-input__wrapper--inline">
          <select name="input-select" value={order} id="input-select" onChange={(e) => {
            dispatch(setOrder(e.target.value))
            dispatch(fetchTasks());
          }}>
            { userLocation.loading === "loaded" && <option value="distance">Afstand</option> }
            <option value="priority" >Prioriteit</option>
            <option value="dueDate">Uiterste datum</option>
            <option value="plannedStartDate">Geplande startdatum</option>
            <option value="taskOrder">Taak volgorde</option>
            <option value="createdAt">Aanmaakdatum</option>
          </select>
          <Icon name="ai-arrow-down-1"/>
        </div>
      </div> }
      </div>
      { (Object.keys(filters).length > 0) && <div className="col-xs-12">
        <h4 className="u-margin-bottom-xs u-margin-top-xs">Filter toegepast</h4>
        <TagList>
          { Object.keys(filters).map((key) => {
          return <Tag
              removable
              key={key}
            label={ <><strong>{translation[key] ?translation[key]: key}: </strong>{ typeof filters[key] === "object" ? filters[key].label : filters[key] } </>}
              onClick={() => {
                const newFilterObject = { ...filters };
                delete newFilterObject[key];
                dispatch(setFilters(newFilterObject));
                dispatch(fetchTasks());
              }}
            />})}
        </TagList>
      </div>}
    </div>
  </div>
}

export default TaskFilter;
